import { defineMessages } from 'react-intl';

const PublishMessages = defineMessages({
  schedule: {
    id: 'publish.schedule',
    defaultMessage: 'Publish',
    description: 'The labels for scheduling deployment'
  },
  alreadyScheduled: {
    id: 'publish.alreadyScheduled',
    defaultMessage: 'Publishing scheduled.',
    description: 'The labels for scheduled deployment'
  },
  'development-environment': {
    id: 'publish.environment.development',
    defaultMessage: 'Development',
    description: 'The header for the dev environment'
  },
  'qa-environment': {
    id: 'publish.environment.qa',
    defaultMessage: 'Testing (QA)',
    description: 'The header for the qa environment'
  },
  'training-environment': {
    id: 'publish.environment.training',
    defaultMessage: 'Training',
    description: 'The header for the training environment'
  },
  'production-environment': {
    id: 'publish.environment.production',
    defaultMessage: 'Production',
    description: 'The header for the production environment'
  }
});

export default PublishMessages;



// WEBPACK FOOTER //
// ./src/apps/Publish/components/PublishMessages.js